import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { ActiveconfirmPage } from '../activeconfirm/activeconfirm';

/**
 * Generated class for the MyactivePage page.
 *
 * Modeled on AvatalistPage ("FunS Coin 리스트") — header + monthly total card +
 * apply/close button + history list. Backend contract confirmed 2026-07-30:
 * active/base returns `button` (0~4) to drive which button/modal variant shows,
 * active/base/index/save takes `divide` ('A' apply | 'C' close).
 */

@IonicPage()
@Component({
    selector: 'page-myactive',
    templateUrl: 'myactive.html',
})
export class MyactivePage {

    loginId: string;
    email: string;
    api_key: string;
    version: string;

    bonus_unit: string;

    // 0: 버튼 없음, 1/2: 신청(최초/재신청), 3/4: 종료(최초/재종료)
    button: number = 0;

    list: any = [];
    balance: any = [];

    texts: any = [];
    language: string;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public alertCtrl: AlertController,
        public modalCtrl: ModalController,
        private http: HttpService,
        public app: App,
        private cd: ChangeDetectorRef
    ) {

    }

    ionViewWillEnter() {
        //// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
        this.api_key = localStorage.getItem("api_key");
        if (!this.api_key) {
            this.app.getRootNav().setRoot(LoginPage);
        }

        //// 페이지 이름
        localStorage.setItem("pageName", "myactive");
        this.loginId = localStorage.getItem("loginId");
        this.email = localStorage.getItem("email");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        this.bonus_unit = localStorage.getItem("bonus_unit");

        this._get_texts();

        this._init();
    }

    _get_texts() {
        this.texts = JSON.parse(localStorage.getItem('lang_pack')).active || {};
    }

    _init(): Promise<void> {
        let url = "active/base";
        let body = JSON.stringify({
            api: this.api_key,
            language: this.language,
            version: this.version
        });
        return this.http.post(url, body).then((res: any) => {
            if (res.result == "OK") {
                this.button = res.button != undefined ? res.button : 0;
                this.balance = res.balance || [];
                this.bonus_unit = res.bonus_unit || this.bonus_unit;

                if (res.list != undefined) {
                    this.list = res.list;
                }
                this.cd.detectChanges();

            } else if (res.result === "LOGOUT") {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);

            } else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        }, (err) => {
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_err,
                buttons: ['OK']
            });
            alert.present();
        });
    }

    _open_apply() {
        let message = (this.button == 1)
            ? (this.texts.active_msg_apply_notice || '신청 즉시 모든 Active 전용 혜택과 멤버십 특전이 시작됩니다.')
            : (this.texts.active_msg_reapply_notice || '종료된 Active를 재신청하고 멤버십 특전을 다시 시작해보세요.');

        let modal = this.modalCtrl.create(ActiveconfirmPage, {
            message: message,
            confirmLabel: this.texts.active_btn_popup_apply || '신청',
            cancelLabel: this.texts.active_btn_popup_cancel || '취소'
        });
        modal.present();
        modal.onDidDismiss((confirmed) => {
            if (confirmed) {
                this._save('A');
            }
        });
    }

    _open_close() {
        let message = (this.button == 3)
            ? (this.texts.active_msg_cancel_notice || '지금 종료하셔도 이번 달 남은 기간까지는 Active 혜택이 계속 유지됩니다.')
            : (this.texts.active_msg_recancel_warning || '정말 Active를 다시 종료하시겠어요? 종료 시 모든 프리미엄 특전과 전용 혜택이 즉시 중단됩니다.');

        let modal = this.modalCtrl.create(ActiveconfirmPage, {
            message: message,
            confirmLabel: this.texts.active_btn_popup_close || '종료',
            cancelLabel: this.texts.active_btn_popup_cancel || '취소'
        });
        modal.present();
        modal.onDidDismiss((confirmed) => {
            if (confirmed) {
                this._save('C');
            }
        });
    }

    _save(divide: string) {
        let url = "active/base/index/save";
        let body = JSON.stringify({
            api: this.api_key,
            language: this.language,
            version: this.version,
            divide: divide
        });
        this.http.post(url, body).then((res: any) => {
            // 이 엔드포인트의 result 값은 믿을 게 못 된다. 2026-08-26 실측에서는 성공해도
            // {"result":"NO","message":"Active 신청이 완료되었습니다."} 처럼 "NO"가 왔고,
            // 2026-08-29 실측에서는 같은 성공에 "OK"가 왔다(서버가 바꾼 것으로 보인다).
            // 어느 쪽이 오든 실제 결과는 message로만 구분 가능하므로, result 값과 무관하게
            // 메시지를 안내하고 최신 상태를 재조회한다.
            if (res.message) {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
            // 신청 성공 시 다음 상태는 반드시 종료 가능(3|4), 종료 성공 시 다음 상태는
            // 반드시 신청 가능(1|2)이므로 재조회를 기다리지 않고 즉시 버튼을 전환해 그린다.
            // (잔액/이력 등 나머지 값과 정확한 상태(최초/재신청 등)는 뒤이은 _init()이 채운다)
            this.button = (divide == 'A') ? 3 : 1;
            this.cd.detectChanges();
            this._init();
        }, (err) => {
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_err,
                buttons: ['OK']
            });
            alert.present();
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/myactive/myactive.ts